import type { ReactElement } from 'react';

import svg from '@/assets/pyramid-loader.svg?raw';
import { cn } from '@/lib/utils';

// The coordinates of the design file.
const VIEWBOX_SIZE = 400;
const VIEWBOX = `${-VIEWBOX_SIZE / 2} ${-VIEWBOX_SIZE / 2} ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`;

// The design file goes in as it is. The root that React renders replaces its root element.
const SHAPES = {
    __html: svg.slice(svg.indexOf('>', svg.indexOf('<svg')) + 1, svg.lastIndexOf('</svg>')),
};

interface Props {
    sizePx: number;
    strokePx: number;
    className?: string;
}

export const PyramidLoader = ({ sizePx, strokePx, className }: Props): ReactElement => (
    <svg
        aria-hidden="true"
        width={sizePx}
        height={sizePx}
        viewBox={VIEWBOX}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokePx * VIEWBOX_SIZE / sizePx}
        strokeLinecap="round"
        className={cn('shrink-0', className)}
        dangerouslySetInnerHTML={SHAPES}
    />
);
